import { c as _c } from "react/compiler-runtime";
import { CampaignStepId } from 'modules/campaigns/campaign-steps/types/campaign-step-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useSenderEmailCheck = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.put
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching
  } = useFetch(t0);
  const getSenderEmailCheckPath = _temp;
  let t1;
  if ($[1] !== fetcher) {
    t1 = (id_0, data) => fetcher(getSenderEmailCheckPath(id_0), data);
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const checkSenderEmail = t1;
  let t2;
  if ($[3] !== checkSenderEmail || $[4] !== isFetching) {
    t2 = {
      checkSenderEmail,
      isFetching
    };
    $[3] = checkSenderEmail;
    $[4] = isFetching;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
function _temp(id) {
  return `/api/dashboard/customer/mailing/campaigns/inactive-steps/${id}/sender-email-address`;
}